import { Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';

const MindSetPage = ({ apiData }) => {
    try {
        Font.register({
            family: 'Lato',
            fonts: [
                { src: LatoRegular, fontWeight: 400 },
                { src: LatoBold, fontWeight: 700 }
            ]
        });

        const styles = StyleSheet.create({
            header: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                color: "#5795B2",
                borderBottom: "1px solid #5795B2"
            },
            title: {
                width: "183px",
                fontSize: "14px",
                fontFamily: "Lato",
                lineHeight: "18px",
                color: "#5795B2",
                fontWeight: 400,

            },
            titlebold: {
                fontWeight: 700
            },
            details: {
                fontSize: "10px",
                fontFamily: "Lato",
                lineHeight: "16px",
                color: "#5795B2",
                fontWeight: 400,
                width: "73px",
                textAlign: "right"

            },
            textbold: {
                fontWeight: 700
            },
            content: {
                marginTop: "16px"
            },
            contenttitle: {
                fontFamily: "Lato",
                fontWeight: 700,
                fontSize: "18px",
                lineHeight: "30px",
                color: "#426B88"
            },
            wrapper: {  // fix spelling
                width: "567px",
                fontFamily: "Lato",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "18px",
                color: "#245775"
            },
            dot: {
                width: "7px",
                height: "7px",
                backgroundColor: "#426B88",
                borderRadius: "100px",
                marginTop: "4px"
            },
            points: {
                marginTop: "20px",    // replace marginVertical
                marginBottom: "20px",  // with separate margins
                marginLeft: "4px"
            },
            point1: {
                display: "flex",
                flexDirection: "row",
                gap: "10px",
            },
            text: {
                marginTop: "20px"
            },
            footer: {
                position: "absolute",
                bottom: "0px",
                borderTop: "1px solid #426B88",
                display: "flex",
                flexDirection: "row",
                width: "571px",
                gap: "30px"
            },
            pagewapper: {
                position: "relative",
                height: "100%"
            },
            footertitle: {
                fontFamily: "Lato",
                fontWeight: 700,
                fontSize: "10px",
                lineHeight: "18px",
                color: "#76A3BE",
                textTransform: "uppercase",
                marginTop: "10px"
            },
            description: {
                color: "#76A3BE",
                fontFamily: "Lato",
                fontWeight: 400,
                fontSize: "8px",
                lineHeight: "18px",
                width: "496px"

            },
            pagenumber: {
                fontFamily: "Lato",
                fontWeight: 700,
                fontSize: "10px",
                lineHeight: "18px",
                color: "#76A3BE",
                marginTop: "10px"
            }
        });

        return (
            <View style={styles.pagewapper}>
                <View style={styles.header}>
                    <View style={styles.title}>
                        <Text style={styles.titlebold}>Quadrant Flow</Text>
                        <Text>Life & Leadership Assessment</Text>
                    </View>
                    <View style={styles.details}>
                        <Text style={styles.textbold}>{apiData?.fullName || 'User'}</Text>
                        <Text>{apiData?.organization || 'Organization'}</Text>
                        <Text>{apiData?.date || new Date().toLocaleDateString()}</Text>
                    </View>
                </View>
                <View style={styles.content}>
                    <Text style={styles.contenttitle}>YOUR MINDSET</Text>
                    <View style={styles.wrapper}>
                        <Text>The Quadrant Flow Assessment evaluates whether your mindset leans toward a fixed or growth perspective. Carol Dweck, Ph.D., a renowned psychologist at Stanford University, identifies these two mindsets as central to how we approach learning and development.</Text>
                        <View style={styles.points}>
                            <View style={styles.point1}>
                                <View style={styles.dot} />
                                <Text>A fixed mindset sees abilities and intelligence as static and predetermined, leading individuals to focus on proving their worth rather than improving.</Text>
                            </View>
                            <View style={styles.point1}>
                                <View style={styles.dot} />
                                <Text>
                                    A growth mindset, on the other hand, views abilities as malleable and capable of development through effort, learning, and persistence.</Text>
                            </View>
                        </View>
                        <Text >
                            Dweck highlights that these mindsets influence how we respond to challenges, feedback, and failure. While those with a fixed mindset prioritize preserving their self-image, often avoiding risks or difficult tasks, individuals with a growth mindset embrace opportunities to grow, even at the risk of failure or appearing foolish. Importantly, these tendencies can vary across different areas of life—someone may exhibit a fixed mindset in one domain and a growth mindset in another.</Text>
                        <Text style={styles.text}>
                            This framework encourages everyone to recognize their potential for growth and to nurture it in all aspects of life. Leaders, parents, educators, and anyone invested in personal development can use these insights to foster continuous learning and improvement.</Text>
                        <Text style={styles.text}>
                            To better understand this spectrum, the Quadrant Flow Assessment, resourced by Healthy Growing Leaders has outlined five distinct levels of mindset development. Each stage reflects a unique relationship with beliefs about intelligence, effort, feedback, and failure, providing clarity on where you are and guiding you toward growth.</Text>
                    </View>
                </View>
                <View style={styles.footer}>
                    <View>
                        <Text style={styles.footertitle}>SELF Report</Text>
                        <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                    </View>
                    <View style={styles.pagenumber}>
                        <Text>PAGE</Text>
                    </View>

                </View>

            </View>
        )
    } catch (error) {
        console.error('Error in MindSetPage:', error);
        return <View><Text>Error loading page</Text></View>;
    }
}

export default MindSetPage